import { App } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiPost, errorMessage, qk } from "@/shared/api";

export function useAdjustBalance(userId: number) {
  const queryClient = useQueryClient();
  const { message } = App.useApp();

  return useMutation({
    mutationFn: (input: { amount: string; comment: string }) =>
      apiPost("/api/v1/admin/users/{user_id}/adjust", {
        params: { user_id: userId },
        // Сумма уходит строкой ровно так, как её ввёл оператор: приведение к
        // number на клиенте потеряло бы копейки на больших суммах.
        body: input,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: qk.user(userId) });
      void queryClient.invalidateQueries({ queryKey: qk.userTransactions(userId) });
      void queryClient.invalidateQueries({ queryKey: ["users"] });
      void queryClient.invalidateQueries({ queryKey: qk.dashboard() });
      void queryClient.invalidateQueries({ queryKey: ["audit"] });
    },
    onError: (error) => {
      void message.error(errorMessage(error));
    },
  });
}
